import React from 'react'
import clsx from 'clsx'
import { CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'

import OverflowTooltip from '../../../atoms/OverflowTooltip'
import TypedUserSearchDropdown from '../../TypedUserSearchDropdown'
import MediaAvatar from '../../../atoms/MediaAvatar'
import FieldCopy from '../FieldCopy'

import { useUserAPI } from '@SonarCX/providers/UserAPIProvider'
import useStyles from '../styles'

type UserInputProps = {
  field: APICustomField
  value: string | null
  handleChange: (
    e: { target: { value: string | null } },
    field: APICustomField,
    row?: number,
    rowKey?: string,
    parent?: APICustomField
  ) => void
  handleBlur?: () => void
  disabled?: boolean
  canEdit?: boolean
  timelineMode?: boolean
  task?: boolean
  inputOnly?: boolean
  row?: number
  rowKey?: string
  parent?: APICustomField
  inTable?: boolean
}

const UserInput: React.FC<UserInputProps> = ({
  field,
  value,
  handleChange,
  handleBlur,
  timelineMode,
  task,
  inputOnly,
  row,
  rowKey,
  parent,
  inTable
}) => {
  const theme = useTheme()

  const { allUsers, loadUser } = useUserAPI()

  const [user, setUser] = React.useState(null)
  const [hovering, setHovering] = React.useState(false)

  React.useEffect(() => {
    if (!value) {
      setUser(null)
      return
    }

    const user = allUsers[value]
    if (user) {
      setUser(user)
    } else {
      loadUser(value)
    }
  }, [value, allUsers, loadUser])

  // @ts-ignore
  const classes = useStyles({ timelineMode, task, inputOnly, inTable })

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={clsx(classes.fieldInputRoot, 'cf-input-root')}
    >
      {!inputOnly && (
        // @ts-ignore
        <OverflowTooltip
          text={field.description}
          className={clsx(classes.label, 'label')}
        >
          {field.title}
        </OverflowTooltip>
      )}

      <FieldCopy inTable={inTable} visible={hovering} text={user?.name ?? ''} />

      {/* @ts-ignore */}
      <TypedUserSearchDropdown
        typeID={field.config?.id}
        prevSelected={[]}
        selected={null}
        onSelect={val => {
          handleChange({ target: { value: val } }, field, row, rowKey, parent)
          if (val !== value) {
            handleBlur && handleBlur()
          }
        }}
        limit={10}
      >
        <div className={classes.select}>
          {user ? (
            <div className={classes.avatar}>
              <MediaAvatar user={user} className='avatar' />

              <div className='name'>{user.name}</div>

              <div
                onClick={e => {
                  e.stopPropagation()
                  setUser(null)
                  handleChange(
                    { target: { value: '' } },
                    field,
                    row,
                    rowKey,
                    parent
                  )
                  handleBlur && handleBlur()
                }}
                className='close'
              >
                <CloseCircle size={theme.size.base} />
              </div>
            </div>
          ) : (
            <div className={classes.avatarNone}>Select user...</div>
          )}
        </div>
      </TypedUserSearchDropdown>
    </div>
  )
}

export default UserInput
